module.exports = kolibriCoreAppGlobal.utils.CatchErrors;